'use strict';

exports.__esModule = true;
exports.sizes = exports.kinds = exports.makeKind = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _darken = require('polished/lib/color/darken');

var _darken2 = _interopRequireDefault(_darken);

var _styles = require('../../styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var makeKind = exports.makeKind = function makeKind(_ref) {
  var color = _ref.color,
      brandColor = _ref.brandColor,
      borderColor = _ref.borderColor,
      hoverColor = _ref.hoverColor,
      hoverBorderColor = _ref.hoverBorderColor,
      activeColor = _ref.activeColor,
      activeBorderColor = _ref.activeBorderColor;

  var border = borderColor || brandColor;
  var hover = hoverColor || (0, _darken2.default)(_styles.colors.hoverDarken, brandColor);
  var hoverBorder = hoverBorderColor || (0, _darken2.default)(_styles.colors.hoverDarken, border);
  var active = activeColor || (0, _darken2.default)(_styles.colors.activeDarken, brandColor);
  var activeBorder = activeBorderColor || (0, _darken2.default)(_styles.colors.activeDarken, border);

  return '\n    color: ' + color + ';\n    background-color: ' + brandColor + ';\n    border-color: ' + border + ';\n    border-radius: 2px;\n    white-space: normal;\n    word-wrap: break-word;\n\n    &:hover {\n      background-color: ' + hover + ';\n      border-color: ' + hoverBorder + ';\n    }\n\n    &:active {\n      background-color: ' + active + ';\n      border-color: ' + activeBorder + ';\n    }\n  ';
};

var kinds = exports.kinds = {
  primary: makeKind({
    color: _styles.colors.white,
    brandColor: _styles.colors.brandPrimaryAccessible,
    hoverColor: (0, _darken2.default)(0.03, _styles.colors.brandPrimaryAccessible),
    activeColor: (0, _darken2.default)(0.05, _styles.colors.brandPrimaryAccessible)
  }),
  secondary: makeKind({
    color: _styles.colors.white,
    brandColor: _styles.colors.brandSecondary
  }),
  success: makeKind({ color: _styles.colors.white, brandColor: _styles.colors.brandSuccess }),
  danger: makeKind({ color: _styles.colors.white, brandColor: _styles.colors.brandDanger }),
  warning: makeKind({ color: _styles.colors.white, brandColor: _styles.colors.brandWarning }),
  labelInsightPurple: makeKind({
    color: _styles.colors.white,
    brandColor: _styles.colors.labelInsightPurple
  }),
  default: makeKind({
    color: _styles.colors.defaultButtonBorderColor,
    brandColor: _styles.colors.white,
    borderColor: _styles.colors.defaultButtonBorderColor
  })
};

var sizes = exports.sizes = {
  small: '\n    padding: 0 0.5rem;\n    font-size: 0.75em;\n    line-height: 1;\n    height: 3rem;\n  ',
  default: '\n    padding: 0 1rem;\n    font-size: 0.875em;\n    line-height: 1;\n    height: ' + _styles.etc.defaultButtonHeight + ';\n  ',
  large: '\n    padding: 0 2.5rem;\n    font-size: 1em;\n    line-height: 1;\n    height: 5rem;\n  '
};

var Button = _styledComponents2.default.button.withConfig({
  displayName: 'Button__Button'
})(['width:', ';border:1px solid;border-radius:', ';font-family:\'Open Sans\',\'Helvetica Neue\',Helmet,Freesans,sans-serif;text-transform:uppercase;letter-spacing:0.5px;cursor:pointer;', ';&:disabled{cursor:not-allowed;color:', ';background-color:', ';border-color:', ';box-shadow:none;}'], function (p) {
  return p.block ? '100%' : 'auto';
}, _styles.etc.inputBorderRadius, function (p) {
  return kinds[p.kind || 'default'] + sizes[p.size || 'default'];
}, function (p) {
  return p.kind === 'default' || !p.kind ? _styles.colors.disabledButtonColor : _styles.colors.white;
}, function (p) {
  return p.kind === 'default' || !p.kind ? _styles.colors.white : _styles.colors.disabledButtonColor;
}, _styles.colors.disabledButtonColor);

Button.propTypes = {
  disabled: _propTypes2.default.bool,
  block: _propTypes2.default.bool,
  kind: _propTypes2.default.oneOf(Object.keys(kinds)),
  size: _propTypes2.default.oneOf(Object.keys(sizes))
};

exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/next/Button/index.js
// module id = 333
// module chunks = 14